export const PRIMARY = { main: '#0052E0', dark: '#003CA6', light: '#307bff', 50: '#F4F8FF', 100: '#E0ECFF' };
export const SECONDARY = { main: '#CDDFFF', dark: '#003CA6', light: '#CDDFFF' };
